<script setup lang="ts">
import { warningSign } from '@/components/icons/icons';
</script>

<template>
  <v-alert
    type="warning"
    :title="$t('NotForClinicalUseTitle')"
    :text="$t('NotForClinicalUseMsg')"
    :icon="warningSign"
    variant="tonal"
    class="prototypeWarning"
  />
</template>
